import { render } from "./SelectProvider.vue?vue&type=template&id=44a1b949&scoped=true"
import script from "./SelectProvider.vue?vue&type=script&lang=js"
export * from "./SelectProvider.vue?vue&type=script&lang=js"

import "./SelectProvider.vue?vue&type=style&index=0&id=44a1b949&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a1b949"]])

export default __exports__